export const phieuXuatKho = {
  sections: {
    list: { title: '出库单' },
    xuatHuy: { title: '报废出库单' },
    xuatTraNcc: { title: '退供应商出库单' },
    detail: { title: '出库单详情' },
    lines: '明细',
  },
  titles: {
    add: '新增',
    addNew: '新增',
    addXuatHuy: '创建报废出库单',
    addXuatTraNcc: '创建退供应商出库单',
  },
  columns: {
    tongSoLuong: '总数量',
    summary: '概要',
    status: '状态',
    ngayTao: '创建时间',
    ngayCapNhat: '更新时间',
    code: '单号',
    chiNhanh: '门店',
    loaiPhieu: '类型',
    ngayChungTu: '凭证日期',
    nhaCungCap: '供应商',
    khachHang: '客户',
    chiNhanhDoi: '对应分支',
    trangThai: '状态',
    tongTienHang: '货品金额',
    maHoaDon: '发票号',
  },
  placeholders: {
    toolbarSearch: '搜索',
    maLoRequired: '必填（效期管理商品）',
    maLoOptional: '非批次管理可留空',
  },
  aria: {
    columnPicker: '选择显示列',
  },
  fields: {
    code: '单号',
    chiNhanh: '门店',
    loaiPhieu: '类型',
    ngayChungTu: '凭证日期',
    nhaCungCap: '供应商',
    khachHang: '客户',
    chiNhanhDoi: '对应分支',
    lyDo: '事由',
    ghiChu: '备注',
    phieuChuyen: '调拨单',
    status: '状态',
    totalAmount: '货品金额',
    product: '商品',
    productCode: '编码',
    productName: '名称',
    productSearch: '搜索商品',
    qty: '数量',
    unitPrice: '出库单价',
    donGiaXuatKho: '出库单价',
    donGiaVon: '成本价',
    donViTinhMua: '采购单位',
    giamGia: '折扣',
    giamGiaPhieu: '整单折扣',
    tongSauGiamGia: '成交额',
    maLo: '序列号/IMEI',
    hanSuDung: '生产日期',
    serialImei: '序列号/IMEI',
    dateSanPham: '生产日期',
    lineAmount: '行金额',
    lineGhiChu: '备注',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    actions: '操作',
  },
  loaiPhieu: {
    XUAT_BAN: '销售出库',
    XUAT_CHUYEN: '调出',
    XUAT_TRA_NCC: '退还供应商',
    XUAT_HUY: '报废出库',
    XUAT_NOI_BO: '内部出库',
    XUAT_DIEU_CHINH: '出库调整',
    XUAT_KHAC: '其他出库',
  },
  detailTabs: {
    chung: '总览',
    generalInfo: '信息',
    chiTietHang: '明细',
    lines: '明细',
  },
  form: {
    loaiPhieu: '类型',
    maPhieu: '单号',
    maPhieuAuto: '保存时自动生成',
    ngayChungTu: '凭证日期',
    nhaCungCap: '供应商',
    khachHang: '客户',
    chiNhanhDoi: '对应分支',
    lyDo: '事由',
    ghiChu: '单据备注',
    note: '单据备注',
    sectionHeader: '基本信息',
    sectionLines: '明细',
    sectionSummary: '汇总',
    product: '商品',
    productSearch: '搜索编码/名称',
    qty: '数量',
    unitPrice: '出库单价',
    donGiaXuatKho: '出库单价',
    donGiaVon: '成本价',
    donViTinhMua: '采购单位',
    maSp: '编码',
    tenSp: '名称',
    giamGia: '折扣',
    giamGiaPhieu: '整单折扣',
    tongSauGiamGia: '成交额',
    maLo: '序列号/IMEI',
    hanSuDung: '生产日期',
    serialImei: '序列号/IMEI',
    dateSanPham: '生产日期',
    lineNote: '备注',
    lineAmount: '行金额',
    tongTienHang: '货品金额',
    tongSoMatHang: '品项数',
    tongSoLuong: '总数量',
    lineCount: '{count} 行',
    save: '保存',
    lotRequired: '批次号必填（效期管理）',
    expiryRequired: '有效期必填（效期管理）',
  },
  status: {
    phieuTam: '草稿',
    daHoanThanh: '已出库',
    daHuy: '已取消',
  },
  filter: {
    maKhachHang: '客户编码',
    tenKhachHang: '客户名称',
    maHangHoa: '商品编码',
    tenHangHoa: '商品名称',
    title: '筛选',
    loaiPhieu: '类型',
    trangThai: '状态',
    khachHang: '客户',
    tuNgay: '起始日期',
    denNgay: '结束日期',
    fromDate: '起始日期',
    toDate: '结束日期',
    dateRangePlaceholder: '选择日期范围',
    all: '全部',
    reset: '重置',
    sortDir: '排序',
    asc: '升序',
    desc: '降序',
    advancedTitle: '高级筛选',
  },
  actions: {
    addLine: '添加空行',
    complete: '完成',
    cancelVoucher: '取消单据',
    copy: '复制单据',
    importExcel: '导入 Excel',
    downloadTemplate: '下载模板',
    dongY: '同意',
  },
  messages: {
    soKhongDuocAm: '数量/单价不能为负数。',
    importDescription:
      '下载模板，填写商品编码/数量/单价/折扣。一个文件创建一张草稿。可直接导入或先预览再编辑。',
    importSuccess: '已从 Excel 导入商品。',
    importWillCreate: '将从 {count} 行商品创建 1 张出库单。',
    importPreviewProgress: '预览出库单',
    importPreviewLoading: '正在准备出库单…',
    importPreviewDone: '已通过预览创建出库单。',
    loadError: '加载出库单失败。',
    noData: '暂无出库单。',
    listSummary: '共计：{count}',
    createSuccess: '已创建出库单并扣减库存。',
    updateSuccess: '已更新出库单。',
    deleteSuccess: '已删除出库单。',
    needLines: '请至少添加一行明细。',
    needNgayChungTu: '保存前请选择凭证日期。',
    validateNgayChungTuBeforeNgayTao: '凭证日期无效。',
    needKhachHang: '保存前请选择客户。',
    needNhaCungCap: '保存前请选择供应商。',
    needChiNhanhDoi: '保存前请选择对应分支。',
    needMaSp: '每行都需填写商品编码。',
    needTenSp: '每行都需填写商品名称。',
    needSoLuong: '每行数量须大于 0。',
    needDonViTinhMua: '每行都需填写采购单位。',
    needMaLo: '请为 {code} 填写序列号/IMEI。',
    needHanSuDung: '请为 {code} 填写生产日期。',
    completeSuccess: '出库单已完成。',
    cancelVoucherSuccess: '出库单已取消。',
    notFound: '未找到单据。',
    noLines: '暂无明细。',
    loadingLines: '正在加载明细…',
    confirmDelete: '删除 {name}？',
    confirmComplete: '完成单据 {name}？库存将被更新。',
    vuotTonTitle: '出库数量超过库存 — 库存将变为负数',
    vuotTonDong: '{ma} – {ten}：出库 {soLuong}，库存 {ton}',
    confirmCancelVoucher: '取消单据 {name}？已扣减的库存将被退回。此操作无法撤销。',
  },
}
